<template>

  <div>
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end actions-wrapper">
                <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por tipo pic..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="primary"
                    @click="openAddModal"
                >
                  <div class="d-flex" style="gap: 5px">
                    <iconfy icon="mdi:plus"/>
                    <span class="">Pic Regra</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refPicRegraListTable"
            class="position-relative"
            :items="fetchPicRegra"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >

          <!-- Column: Actions -->
          <template #cell(regrapiccliente)="data">
            <span>{{ data.item.regrapiccliente ? 'Sim' : 'Não' }}</span>
          </template>
          <template #cell(regrapicrede)="data">
            <span>{{ data.item.regrapicrede ? 'Sim' : 'Não' }}</span>
          </template>
          <template #cell(actions)="data">
            <div>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-primary"
                  title="Visualizar e Editar"
                  class="btn-icon mr-1"
                  @click="openEditModal(data.item)"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>

              <b-button
                  variant="gradient-danger"
                  title="Deletar"
                  class="btn-icon"
                  @click="openModalDeleteCustomField(data.item)"
              >
                <feather-icon icon="TrashIcon"/>
              </b-button>
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalPicRegra"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAdd
        idModal="modal-add-pic-regra"
        titleModal="Adicionar Pic Regra"
        :labelBtnOk="'Adicionar'"
        v-model="dataPicRegra"
        @ok="create($event)"
        @cancel="resetFormData()"
    />
    <ModalAtt
        idModal="modal-att-pic-regra"
        titleModal="Atualizar Pic Regra"
        :labelBtnOk="'Atualizar'"
        v-model="dataPicRegra"
        @ok="Updated($event)"
        @cancel="resetFormData()"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-tipo-pic"
        title="Deletar Pic Regra"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedCustomField.tipopicid)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Pic Regra?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axios from '@/libs/axios';
import ModalAdd from './ModalAdd.vue';
import ModalAtt from './ModalAtt.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    ModalAtt,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      idEdit: null,
      dataFromApiTipoPicId: '',
      isDeleteModal: false,
      deletedCustomField: {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      },
      searchInputValue: '',
    };
  },
  // mounted() {
  //   this.fetchDataFromTipoPic()
  // },
  methods: {
    async fetchDataFromTipoPic() {
      try {
        const response = await axios.get('/tipo-pic');
        this.dataFromApiTipoPicId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Pic Regra deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataPicRegra = data;
      this.idEdit = data.tipopicid;
      this.$bvModal.show('modal-att-pic-regra');
    },
    openAddModal() {
      this.resetFormData();
      this.$bvModal.show('modal-add-pic-regra');
    },
    resetFormData() {
      this.deletedCustomField = {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      };
      this.dataPicRegra = {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      };
      this.isDeleteModal = false;
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const customFields = ref([]);
    const dataPicRegra = ref({
      tipopicid: null,
      regrapiccliente: '',
      regrapicrede: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalPicRegra,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refPicRegraListTable,
      fetchPicRegra,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      create,
      Updated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      currentTab,
      dataPicRegra,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalPicRegra,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchPicRegra,
      overlay,
      tableColumns,
      refPicRegraListTable,
      create,
      Updated,
      removerData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
